import { Component, OnInit } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import {UtilsModule} from 'src/app/common/utils/utils.module';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-download-excel',
  templateUrl: './download-excel.component.html',
  styleUrls: ['./download-excel.component.css']
})
export class DownloadExcelComponent implements OnInit {

  showdistdropdown : Boolean;
  districtflag : Boolean;
  excelDownloadData : object = {'lu':'','distuuid':'','ay':'','month':'','pu':'','au':'','ft':'','view':'admin','datasubmit':'statewise'};
  validfilechack : boolean =false;
  activespineer : boolean =false;
  fieldDropDownList : object = {AssesmentList:[],StateList:[],DistrictList:[],FiletypeList:[],AssesmentListDistrict:[]};
   validation: boolean[] = new Array(4).fill(true);
   userdetails : any;
   datasubmitted = 'districtwise';
   windowdata : any;
   disablesubmit : boolean = false;
  state_nodal_officer: string;
  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  monthsList: any;
  selectedMonth: any;
  parentuuid: any;
  yearDropDownList: any;
  constructor(private submitdataService : SubmitdataService,
    public utils : UtilsModule,
    public constants : ConstantsModule,
    private logsrv : AuthloginService) { }

  ngOnInit() {
    this.updateDefaultList();
  }
  public updateDefaultList(){
    this.userdetails = this.logsrv.checkloginstatus();
    this.excelDownloadData['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    this.parentuuid = this.userdetails ? this.userdetails['loggedUserData']['userProfile']['stateUUID'] : null;
    // this.getAssesmentYear();
    this.yearDropDownList = this.submitdataService.getassesmentYear();
    this.getassesmentunit();
    this.getLocationList('district');
    this.excelDownloadData['ay'] = this.yearDropDownList[this.yearDropDownList.length-1];
    this.monthsList = this.monthList;
    this.setCurrentMonthDefault();
  }
  getAssesmentYear(){
    this.fieldDropDownList['AssesmentList'] = this.submitdataService.getassesmentYear();
  }
  dataSubmissionChange(){
  }
  selectOption(month){
    this.selectedMonth = month
  }
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.excelDownloadData['month'] = currentmonthObj['key'];
  }
  getLocationList(type){
    if(type == 'district'){
      let option = {
        'pType':this.constants.LOCATION_CONSTANT['STATE'],
        'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
        'puuid': this.excelDownloadData['lu']
      };
      this.activespineer = true;
      this.submitdataService.getLocationListforUser(option).subscribe(data =>{
        this.activespineer = false;
        if(Array.isArray(data)){
          this.fieldDropDownList['DistrictList'] = data;
          console.log(this.fieldDropDownList['DistrictList']);
        }
       
    },function(err){
      console.log("error"); 
        this.activespineer = false;
        if(err['error']){
          this.toastr.error(err['error']['msg'])
        }
      })
    }
  }
  async getassesmentunit(){
      this.activespineer = true;
     console.log(this.userdetails);
     let options = {
       "st" : this.excelDownloadData['lu'],
       "userId" : this.userdetails.loggedUserData.userProfile.userId
     }
    this.showdistdropdown = await this.submitdataService.getAssesmentData(options);
    this.districtflag = false
  }
  downloadexcelData(){
    if(this.Basicvalidation()){
      this.activespineer = true;
     let postdata = {
       "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
       "puuid" : this.parentuuid,
       "pType" : this.constants.LOCATION_CONSTANT['STATE'],
       "ay" : this.excelDownloadData['ay'],
       "view" : this.constants.VIEWS['admin'],
       "lu" : this.userdetails ? this.userdetails['loggedUserData']['userProfile']['locationId'] : null,
       "component" : 1,
       "subTp" : this.excelDownloadData['month']
     }
     this.submitdataService.downloadExcelData(postdata).subscribe(result =>{
      this.activespineer = false;
      if(!Array.isArray(result)){
        let fname = (this.districtflag ? this.getdistname() : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityName']) +"_" + (new Date()).getTime() + ".xls"
    
        this.utils.downloadFile(result, fname);
      }
     
    })
    
    
  }
    }
    getdistname(){
      let name;
      this.fieldDropDownList['DistrictList'].forEach(element => {
        if(element['uuid'] == this.excelDownloadData['distuuid']){
          name = element['name']
        }
      });
      return name;
    }
  public Basicvalidation():boolean{
    this.validation[0] = this.utils.checkfield(this.excelDownloadData['ay'])
    this.validation[1] = this.utils.checkfield(this.excelDownloadData['month'])
      return this.validation[0] && this.validation[1];
   }

}
